<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";
import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";

useBackButton();

const viewModel = await useViewModelInstance();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Run out of Fuel?</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <p>
                <span v-if="viewModel.carePlan.roadsideAssistance.isEnabled" 
                      class="dark:text-white">Step 1 - 
                </span>
                <span class="dark:text-white">Acceptance:</span>
                Embrace the fact that your car is now a very expensive paperweight and start planning your next move.
            </p>

            <div v-if="viewModel.carePlan.roadsideAssistance.isEnabled">
                <p>
                    <span class="dark:text-white">Step 2 - Call in backup:</span>
                    Give your Roadside Assist provider a buzz. Don't have one? Not to worry, Carbucks has partnered with
                    Roadside Assist providers that will be able to assist even if you aren't a member.
                </p>

                <div class="flex justify-center py-4">
                    <RoadsideAssistanceButton /> 
                </div>
            </div>
                
            <div class="flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    Remember, running out of fuel isn't the end of the world; it's just a pit stop on the 
                    journey of life. So, buckle up, enjoy the ride, and never forget to check your fuel gauge!
                </p>        

            </div>

        </div>

    </div>   
    
</template>
